<template>
  <div class="flex justify-between items-center">
    <template v-for="(step, index) in steps" :key="step.id">
      <div class="flex flex-col items-center transform transition-all duration-300 ease-out hover:scale-105">
        <div
            :class="[
            'h-10 w-10 rounded-full flex items-center justify-center text-sm transform transition-all duration-500',
            currentStep >= step.id
              ? 'bg-blue-600 text-white scale-100 shadow-lg'
              : 'bg-gray-200 text-gray-500 scale-95',
          ]"
        >
          {{ step.id }}
        </div>
        <span
            :class="[
            'text-xs mt-2 font-medium transition-all duration-300',
            currentStep >= step.id
              ? 'text-blue-600 transform translate-y-0 opacity-100'
              : 'text-gray-500 transform translate-y-1 opacity-75',
          ]"
        >
          {{ step.name }}
        </span>
      </div>

      <div
          v-if="index < steps.length - 1"
          :class="[
          'h-[2px] flex-1 mx-2 transform transition-all duration-500',
          currentStep > index + 1
            ? 'bg-blue-600 scale-x-100'
            : 'bg-gray-200 scale-x-95',
        ]"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
interface Step {
  id: number;
  name: string;
}

defineProps({
  currentStep: {
    type: Number,
    required: true,
  },
});

const steps: Step[] = [
  {id: 1, name: "Email"},
  {id: 2, name: "SĐT"},
  {id: 3, name: "OTP"},
];
</script> 